module.exports = __webpack_public_path__ + "img/coc.6b4f2c4a.png";